import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthManagementService } from '@core/service/auth-management.service';
import { UserRole } from '@core/models/Enums/UserRole';
import { NavigationHistoryService } from '@core/service/navigation-history.service';
import Swal from 'sweetalert2';

export const roleGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot
): boolean | UrlTree => {

  const auth = inject(AuthManagementService);
  const router = inject(Router);
  const navigationHistory = inject(NavigationHistoryService);

  const allowedRoles = (route.data?.['roles'] ?? []) as UserRole[];

  // Si no definiste roles, deja pasar
  if (!allowedRoles.length) {
    return true;
  }

  // Si no está autenticado → login
  if (!auth.isAuthenticated()) {
    return router.createUrlTree(['/authentication/signin']);
  }

  // Si tiene alguno de los roles permitidos
  if (auth.hasRole(allowedRoles)) {
    return true;
  }

  // Si no tiene permisos → alerta
  Swal.fire({
    icon: 'warning',
    title: 'ACCESO DENEGADO',
    text: 'NO TIENES PERMISOS PARA ACCEDER A ESTA PANTALLA.',
    confirmButtonText: 'ACEPTAR'
  });

  const previousUrl = navigationHistory.getPreviousUrl();

  // Regresar a la ruta anterior si existe
  if (previousUrl && previousUrl !== router.url) {
    return router.parseUrl(previousUrl);
  }

  // Si no existe ruta previa → ruta por defecto
  return router.createUrlTree([auth.getDefaultRoute()]);
};
